import React, { useState, useEffect, useCallback } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PaginationDataTable from "../../Common/PaginationDataTable";
import { REQUISITION_URL } from "../../../CONSTANTS";
import { useMemo } from "react";
import { handleRequisitionActiveInactive } from "../../../services/Production/RequisitionServices";

const RequisitionList = (props) => {
    const navigate = useNavigate();
    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState("");
    const [rows, setRows] = useState([]);
    const [refreshFlag, setRefreshFlag] = useState(0);


    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);






    const handleActiveInactive = (row) => {
        handleRequisitionActiveInactive(row.recordId).then((res) => {
            if (res.errorCode === 0) {
                handleRefresh()
                toast(res.message,{id:123});
            } else {
                toast(res.message);
                return;
            }
        });
    };


    const columns = useMemo(
        () => [
            {
                name: "REQ NO.",
                selector: (row) => row.requisitionCode,
                style: { color: "#007bff", cursor: "pointer" },
            },

            {
                name: "DEPT",
                selector: (row) => row.requestingDepartmentTitle,
            },
            {
                name: "USER",
                selector: (row) => row.requestingUserTitle,
            },
            {
                name: "DATE",
                selector: (row) => row.requestDate,
            },
            {
                name: "ACCEPTED",
                cell: (row) => (
                    <span className={row.isAccepted ? "led-green" : "led-red"} title={row.isAccepted ? "Accepted" : "Rejected"}></span>
                ),
                width: "120px",
            },
            {
                name: "ACTION",
                selector: (row) => (
                    <div>
                        {!row?.isAccepted && <EditIcon
                            style={{ fontSize: "15px", cursor: "pointer" }}
                            onClick={() => {
                                navigate("/requisition/edit", { state: { reqId: row.recordId } });
                            }}
                        />}
                        {!row?.isAccepted && !row?.isRejected && (row.active ? (
                            <CheckCircleIcon
                                style={{
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    color: 'greenyellow',
                                }}
                                onClick={() => handleActiveInactive(row)}
                            />
                        ) : (
                            <CancelIcon style={{ fontSize: '15px', cursor: 'pointer', color: 'tomato' }} onClick={() => handleActiveInactive(row)} />
                        ))}
                    </div>
                ),
            },
        ], [handleRefresh]
    )

    const handleRowClick = (row) => {
        if (props.onRowClicked) {
            props.onRowClicked(row);
        }
        const recordId = row.recordId;
        if (recordId) {
            navigate(`/requisition/${recordId}`);
        }
    };
    const handleClickNew = () => {
        navigate('/requisition/new');
    };

    useEffect(() => {
        const result = rows.filter((data) => {
            return data?.requestDate.toLowerCase().includes(search.toLowerCase()) || data?.requisitionCode.includes(search);
        });
        setFilteredData(result);
    }, [search]);

    return (
        <>
            <div style={{ height: 500, width: "100%" }}>
                <PaginationDataTable
                    paginationUrl={
                        REQUISITION_URL() + "getAllRecords"
                    }
                    serverSidePagination={true}
                    search={true}
                    pagination={false}
                    columns={columns}
                    onRowClicked={handleRowClick}
                    onNewClicked={handleClickNew}
                />
            </div>

            <Toaster />
        </>
    );
};

export default RequisitionList;
